import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@common/contexts/UserContext';
import { createDashboard } from '@api/dashboard';
import DashboardEditor from '../Dashboard/DashboardEditor';

function ReportCreatePage() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [saving, setSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = useCallback(
    async (reportData) => {
      setSaving(true);
      setSaveSuccess(false);
      setError(null);

      try {
        const reportDataWithCreator = {
          ...reportData,
          creator: user?.id ? String(user.id) : undefined,
        };
        if (!reportDataWithCreator.creator) {
          delete reportDataWithCreator.creator;
        }

        const response = await createDashboard(reportDataWithCreator);

        if (response.status === 'success') {
          setSaveSuccess(true);
          navigate('/');
        } else {
          setError(`Failed to save report: ${response.message}`);
        }
      } catch (err) {
        setError(`Failed to save report: ${err.message}`);
      } finally {
        setSaving(false);
      }
    },
    [user, navigate],
  );

  const handleCancel = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <DashboardEditor
      dashboard={null}
      isCreating
      saving={saving}
      saveSuccess={saveSuccess}
      error={error}
      onSave={handleSave}
      onCancel={handleCancel}
    />
  );
}

export default ReportCreatePage;
